(function() {

    var state = {
            simfree: null,
            simonly: null
        },
        $widget = null,
        elem = {
            dealBuilderHandsetSection: $('[data-deal-builder-section="handset"]'),
            dealBuilderSimSection: $('[data-deal-builder-section="sim"]'),
            dealBuilderDealSection: $('[data-deal-builder-section="deal"]'),
            builderInfoPlaceHolder: $('[data-deal-builder-info-placeholder]'),
            builderInfo: $('[data-deal-builder-info]'),
            totalInfo: $('[data-deal-total-info]'),
            simOnlyPlaceHolder: $('[data-deal-builder-tariff-placeholder]'),
            simFreePlaceHolder: $('[data-deal-builder-handset-placeholder]'),
            discountHeader: $('[data-discount-header]'),
            simOnlyInfo: $('[data-deal-builder-tariff-info]'),
            simFreeInfo: $('[data-deal-builder-handset-info]'),
            discountDiv: $('[data-cgm-discount]'),
            tariffBeforeCashback: $('[data-tariff-before-cashback]'),
            dealBeforeCashback: $('[data-deal-before-cashback]'),
        };

    function getSimFreeInfo() {
        var $handsetInfo = $('[data-deal-builder-handset-info]');
        setSimFreeState({
            buyId: $handsetInfo.data('buy-id'),
            name: $handsetInfo.data('name'),
            giftCode: $handsetInfo.data('buy-gift-code'),
            imageUrl: $handsetInfo.data('image-url'),
            price: getPrice($handsetInfo.data('price')),
            capacity: $handsetInfo.data('capacity'),
            colour: $handsetInfo.data('colour')
        });
    }

    function getSimOnlyInfo() {
        var $tariffInfo = $('[data-deal-builder-tariff-info]');
        setSimOnlyState({
            buyId: $tariffInfo.data('buy-id'),
            name: $tariffInfo.data('name'),
            giftCode: $tariffInfo.data('buy-gift-code'),
            imageUrl: $tariffInfo.data('image-url'),
            monthlyCost: $tariffInfo.data('monthly-price'),
            effectiveCost: $tariffInfo.data('effective-cost'),
            totalCostBeforeCashback: getPrice($tariffInfo.data('total-cost-before-cashback')),
            totalCostAfterCashback: getPrice($tariffInfo.data('total-cost-after-cashback')),
            contractLength: $tariffInfo.data('contract-length'),
            giftName: $tariffInfo.data('gift-name'),
            discountPrice: isDiscountEnabled() ? 500.00 : 0
        });
    }

    function setSimFreeState(input) {
        state.simfree = {
            buyId: input ? input.buyId : '',
            name: input ? input.name : '',
            capacity: input ? input.capacity : '',
            colour: input ? input.colour : '',
            giftCode: input ? input.giftCode : '',
            imageUrl: input ? input.imageUrl : '',
            price: input ? input.price : 0
        };
    }

    function setSimOnlyState(input) {
        state.simonly = {
            buyId: input ? input.buyId : '',
            name: input ? input.name : '',
            giftCode: input ? input.giftCode : '',
            imageUrl: input ? input.imageUrl : '',
            monthlyCost: input ? input.monthlyCost : 0,
            effectiveCost: input ? input.effectiveCost : 0,
            totalCostBeforeCashback: input ? input.totalCostBeforeCashback : 0,
            totalCostAfterCashback: input ? input.totalCostAfterCashback : 0,
            contractLength: input ? input.contractLength : 0,
            tariffData: input ? input.tariffData : 0,
            tariffMinutes: input ? input.tariffMinutes : 0,
            tariffTexts: input ? input.tariffTexts : 0,
            giftName: input ? input.giftName : '',
            discountPrice: (input && isDiscountEnabled()) ? input.discountPrice : 0
        };
    }

    function toggleDealBuilderWidget(action) {
        $('#collapseOne').collapse(action);
        if (action !== 'show') {
            var timer = setInterval(function() {
                if (!($('[data-builder-collapsible]').hasClass('collapsing'))) {
                    onClickScrollToListings();
                    clearInterval(timer);
                }
            }, 200);
        }
    }

    function onClickScrollToListings() {
        var isE2save = $('body').hasClass('wl-e2save');
        $container = isE2save ? $('.panel-body.listing-tiles') : $('[data-tariff-container]');
        $('html, body').animate({
            scrollTop: $container.offset().top - 50
        }, 700);
    }

    function initDealBuilder() {
        var $accordion = $('[data-builder-collapsible]');
        $widget = $('[data-deal-builder-page]');

        getSimFreeInfo();
        getSimOnlyInfo();

        state.dealBuilderPage = getDealBuilderPage();
        pushState();

        $(document).on('cdt.deals-loaded', function() {
            pushState();
        });

        $(document).on('click', '[data-remove-sim]', onClickRemoveSim);
        $(document).on('click', '[data-remove-handset]', onClickRemoveHandset);
        $(document).on('click', '[data-add-plan]', onClickAddPlanButton);
        $(document).on('click', '[data-add-handset]', onClickAddHandsetButton);
        $(document).on('click', '[data-view-sims]', onClickViewListings);
        $(document).on('click', '[data-view-handsets]', onClickViewListings);

        $accordion.collapse('show');

        $accordion.on('hidden.bs.collapse', afterWidgetHidden);
        $accordion.on('show.bs.collapse', afterWidgetShown);

        $(window).on('resize', onWindowResize);

        if ($widget.data('deal-builder-switch')) {
            setWidgetShadowHeight('short');
            toggleDealBuilderWidget('hide');
        }

        $(window).resize();

        addColourChangeFunctionIfMissing();
        hideMonthlyPricesBeforeCashback();
    }

    function setWidgetShadowHeight(className) {
        $('[data-builder-shadow]').removeClass('short long').addClass(className + (isDiscountEnabled() ? '' : ' discount-enabled'));
    }

    function afterWidgetHidden() {
        setWidgetShadowHeight('short');
        $('[data-builder-chevron]').toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
        $('.builder-parent').toggleClass('builder-parent-tab');
    }

    function afterWidgetShown() {
        setWidgetShadowHeight('long');
        $('[data-builder-chevron]').toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
    }

    function onWindowResize() {
        var $accordion = $('.deal-builder-accordion');
        if ($accordion.css('position') === 'fixed') {
            $accordion.css('width', $('[data-deal-builder-page]').css('width'));
        } else {
            $accordion.css('width', '');
        }
    }

    function onClickRemoveHandset() {
        setSimFreeState();
        if (state.dealBuilderPage === 'simfree') {
            pushState();
            toggleDealBuilderWidget('hide');
        } else {
            redirectToSimFree();
        }
    }

    function onClickRemoveSim() {
        setSimOnlyState();
        updateDealInfo();

        if (state.dealBuilderPage === 'simfree') {
            redirectToSimOnly();
        } else {
            pushState();
            toggleDealBuilderWidget('hide');
        }
    }
    function updateSimOnlyButtonText(text) {
        $('[data-button-type="add-plan"]').text(text);
    }

    function updateSimFreeButtonText(text) {
        var $button = $('[data-button-type="add-handset"]');
        $button.text(text);
    }

    function updateBuyLink() {
        var href = encodeURI('/buy/' + state.simonly.buyId + '/' + state.simonly.giftCode + '/' + state.simfree.buyId);
        $('[data-deal-buy-link]').prop('href', href);
    }

    function onClickAddPlanButton() {
        var $plan = $(this);
        setSimOnlyState({
            buyId: $plan.data('buy-id'),
            name: $plan.data('name'),
            giftCode: $plan.data('buy-gift-code'),
            imageUrl: $plan.data('image-url'),
            monthlyCost: $plan.data('monthly-price'),
            effectiveCost: $plan.data('effective-cost'),
            totalCostBeforeCashback: getPrice($plan.data('total-cost-before-cashback')),
            totalCostAfterCashback: getPrice($plan.data('total-cost-after-cashback')),
            contractLength: $plan.data('contract-length'),
            tariffData: $plan.data('tariff-data'),
            tariffMinutes: $plan.data('tariff-minutes'),
            tariffTexts: $plan.data('tariff-texts'),
            giftName: $plan.data('gift-name'),
            discountPrice: isDiscountEnabled() ? 500.00 : 0
        });
        pushState();
        jumpToDealBuilder();
        toggleDealBuilderWidget('show');
    }

    function onClickAddHandsetButton() {
        var $handset = $(this);
        setSimFreeState({
            buyId: $handset.data('buy-id'),
            giftCode: $handset.data('buy-gift-code'),
            name: $handset.data('name'),
            colour: $handset.data('colour'),
            capacity: $handset.data('capacity'),
            imageUrl: $handset.data('image-url'),
            price: getPrice($handset.data('price'))
        });
        pushState();
        jumpToDealBuilder();
        toggleDealBuilderWidget('show');
    }

    function pushState() {
        updateHandsetInfo();
        updateTariffInfo();
        updateDealInfo();
        updateBuyLink();
    }

    function onClickViewListings() {
        var isSimFreeLink = $(this)[0].hasAttribute('data-view-sims');
        if (!isSimFreeLink && window.location.toString().indexOf('/sim-free') === -1) {
            redirectToSimFree();
            return;
        }
        if (isSimFreeLink && window.location.toString().indexOf('/sim-only') === -1) {
            redirectToSimOnly();
            return;
        }
        setWidgetShadowHeight('short');
        toggleDealBuilderWidget('hide');
    }

    function redirectToSimFree() {
        redirectToUrl('sim-free');
    }

    function redirectToSimOnly() {
        redirectToUrl('sim-only');
    }

    function redirectToUrl(target) {
        window.location.replace('/deal-builder/' + target + '?simOnlyId=' + state.simonly.buyId + '&simFreeId=' + state.simfree.buyId + '&switch=1');
    }

    function jumpToDealBuilder() {
        $('html, body').animate({
            scrollTop: 0
        }, 700);
    }

    function updateHandsetInfo() {
        if (state.simfree.buyId === '') {
            hideSimFreeInfo();
            updateSimFreeButtonText('Add Handset');
        } else {
            var discountPrice = state.simonly.discountPrice;
            $('[data-handset-name]').text(state.simfree.name);
            $('[data-handset-price]').text((state.simfree.price).toFixed(2));
            if (isDiscountEnabled()) {
                $('[data-handset-discounted-price]').text(
                    (discountPrice ? discountPrice : 0).toFixed(2)
                );
            }
            $('[data-handset-capacity]').text(state.simfree.capacity);
            $('[data-handset-colour]').text(state.simfree.colour);
            var $handsetImg = $('[data-deal-builder-handset-image]');
            $handsetImg.prop('src', state.simfree.imageUrl);
            $handsetImg.prop('alt', state.simfree.name);
            showSimFreeInfo();
            updateSimFreeButtonText('Switch Handset');
        }
    }

    function updateTariffInfo() {
        if (state.simonly.buyId === '') {
            hideSimOnlyInfo();
            updateSimOnlyButtonText('Add Plan');
        } else {
            $('[data-tariff-name]').text(state.simonly.name);
            $('[data-tariff-monthly-cost]').text(state.simonly.monthlyCost);
            $('[data-tariff-effective-cost]').text(state.simonly.effectiveCost);
            $('[data-builder-tariff-data]').text(state.simonly.tariffData);
            $('[data-builder-tariff-minutes]').text(state.simonly.tariffMinutes);
            $('[data-builder-tariff-texts]').text(state.simonly.tariffTexts);
            $('[data-builder-gift-name]').html(state.simonly.giftName);
            var $tariffImg = $('[data-deal-builder-tariff-image]');
            $tariffImg.prop('src', state.simonly.imageUrl);
            $tariffImg.prop('alt', state.simonly.name);
            showSimOnlyInfo();
            updateSimOnlyButtonText('Switch Plan');

            if (state.simonly.effectiveCost === state.simonly.monthlyCost) {
                hideMonthlyPricesBeforeCashback();
            } else {
                showMonthlyPricesBeforeCashback();
            }
        }
    }

    function updateDealInfo() {
        hideTotalInfo();
        var dealPrice = (state.simfree.price).toFixed(2);
        $('[data-deal-price]').text(dealPrice === 'NaN' ? ' -' : dealPrice);
        $('[data-deal-monthly-price-after-cashback]').text(state.simonly.effectiveCost);
        $('[data-deal-monthly-price-before-cashback]').text(state.simonly.monthlyCost);
        $('[data-buy-gift-code]').prop('buy-gift-code', state.simonly.giftCode);

        if ((state.simonly.buyId === '') || (state.simfree.buyId === '')) {
            hideBuilderInfo();
            updateDiscountValue(false);
            return;
        }
        showBuilderInfo();

        if (state.simonly.effectiveCost === state.simonly.monthlyCost) {
            hideMonthlyPricesBeforeCashback();
        } else {
            showMonthlyPricesBeforeCashback();
        }

        var simOnlyCost = state.simonly.totalCostAfterCashback;
        var dealDuration = parseInt(state.simonly.contractLength, 10);

        if (dealDuration === 1) {
            simOnlyCost *= 12;
            dealDuration *= 12;
        }
        var dealTotalCostAfterCashback = simOnlyCost + state.simfree.price;

        if (!isNaN(dealDuration) && (dealDuration % 12) === 0) {
            dealDuration = dealDuration / 12;
            var dealDurationString = dealDuration + ' year' + ((dealDuration > 1) ? 's' : '');

            $('[data-deal-total-cost-after-cashback]').text(dealTotalCostAfterCashback.toFixed(2));
            $('[data-deal-duration]').text(dealDurationString);
        }
        updateDiscountValue(true);
        showTotalInfo();
    }

    function updateDiscountValue(performStrikethrough) {
        var savings = state.simfree.price - state.simonly.discountPrice;
        if (isDiscountEnabled() && performStrikethrough) {
            $('[data-discount-header-price]').text(savings.toFixed(2));
            $('[data-handset-price-parent]').addClass('strikethrough');
        } else if (isDiscountEnabled()) {
            $('[data-handset-price-parent]').removeClass('strikethrough');
        }
    }

    function getDealBuilderPage() {
        if ($widget.data('deal-builder-page')) {
            return ($widget.data('deal-builder-page').toString() === 'simfree') ? 'simfree' : 'simonly';
        }
    }

    function showTotalInfo() {
        elem.totalInfo.show();
        if (isDiscountEnabled()) {
            if (elem.discountHeader.hasClass('hide')) {
                elem.discountHeader.removeClass('hide');
                elem.discountDiv.removeClass('hide');
            }
            elem.discountDiv.show();
            elem.discountHeader.show();
        }
    }

    function hideTotalInfo() {
        elem.totalInfo.hide();
        if (isDiscountEnabled()) {
            elem.discountDiv.hide();
            elem.discountHeader.hide();
        }
    }

    function showSimOnlyInfo() {
        elem.simOnlyPlaceHolder.hide();
        elem.dealBuilderSimSection.addClass('selected-item');
        elem.simOnlyInfo.show();
    }

    function hideSimOnlyInfo() {
        elem.simOnlyInfo.hide();
        elem.simOnlyPlaceHolder.show();
        elem.dealBuilderSimSection.removeClass('selected-item');
    }

    function showSimFreeInfo() {
        elem.simFreePlaceHolder.hide();
        elem.simFreeInfo.show();
        elem.dealBuilderHandsetSection.addClass('selected-item');
    }

    function showBuilderInfo() {
        elem.builderInfoPlaceHolder.hide();
        elem.dealBuilderDealSection.addClass('selected-item');
        $('[data-deal-builder-steps]').addClass('deal-builder-steps-completed');
        elem.builderInfo.show();
    }

    function hideBuilderInfo() {
        elem.builderInfo.hide();
        elem.dealBuilderDealSection.removeClass('selected-item');
        $('[data-deal-builder-steps]').removeClass('deal-builder-steps-completed');
        elem.builderInfoPlaceHolder.show();
    }

    function hideSimFreeInfo() {
        elem.simFreeInfo.hide();
        elem.simFreePlaceHolder.show();
        elem.dealBuilderHandsetSection.removeClass('selected-item');
    }

    function showMonthlyPricesBeforeCashback() {
        elem.tariffBeforeCashback.show();
        elem.dealBeforeCashback.show();
    }

    function hideMonthlyPricesBeforeCashback() {
        elem.tariffBeforeCashback.hide();
        elem.dealBeforeCashback.hide();
    }

    function addColourChangeFunctionIfMissing() {
        if (typeof onTariffTableColourChange !== 'function') {
            window.onTariffTableColourChange = function($listingTile, selectedColour) {
                var variations = $listingTile.children('[data-listing-tile-variation]');

                var selectedVariation = $($.grep(variations, function(elem) {
                    return $(elem).attr('data-variation-color') === selectedColour;
                })).first();

                if (selectedVariation.length) {
                    variations.removeClass('active');
                    selectedVariation.addClass('active');
                }
            };

            window.onTariffTableColourSwatchClick = function(event) {
                event.preventDefault();
                var $swatch = $(this);
                onTariffTableColourChange($swatch.closest('.item'), $swatch.attr('data-variation-color'));
            };

            $(document).on('click', '[data-listing-tile-variation] [data-tile-colors] a', onTariffTableColourSwatchClick);
        }
    }

    function isDiscountEnabled() {
        return elem.discountHeader.length !== 0;
    }

    function getPrice(priceString) {
        if (priceString) {
            priceString = priceString.toString().replace(/[^\d.]/gi, '');
        }
        return parseFloat(priceString);
    }

    if ($('#deal-builder-header').length) {
        initDealBuilder();
    }
})();
